// import external dependencies
import 'core-js/stable';

// import app init
import { init } from 'srt-core/app';

// start app
$(document).ready(function() {
  init();
});
